import {
	Component,
	ChangeDetectionStrategy,
	Input,
	Output,
	EventEmitter,
} from '@angular/core';

import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { EmptyPlaceholderComponent } from '../empty-placeholder/empty-placeholder.component';
import { NgxTolgeeModule } from '@tolgee/ngx';

export interface IAuTableContainerPlaceholderData {
	title: string;
	description: string;
	descriptionClass?: string;
	buttonText: string;
	iconName?: string;
	width?: number;
	placeholderPath?: string;
}

@Component({
	selector: 'au-table-container',
	templateUrl: './au-table-container.component.html',
	styleUrls: ['./au-table-container.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatProgressSpinner, EmptyPlaceholderComponent, NgxTolgeeModule],
})
export class AuTableContainerComponent {
	@Input() isLoadingResults: boolean;
	@Input() isDataAndConfigProvided: boolean = false;
	@Input() isFilteringApplied: boolean = false;
	@Input() emptyPlaceholderData: IAuTableContainerPlaceholderData;
	@Input() tableDataTypeName = 'Results'; // like 'Work orders' or 'Tasks'

	@Output() emptyPlaceholderBtnClicked = new EventEmitter<void>();

	emptyPlaceholderActionClicked() {
		this.emptyPlaceholderBtnClicked.emit();
	}
}
